import React from "react";
import styled from "styled-components/macro";

export enum LoaderEnum {
    small = '20',
    medium = '50',
    large = '100'
}

interface MiniLoaderProps {
    color: string
    size: LoaderEnum
}

export const MiniLoader = ({color, size}: MiniLoaderProps): React.ReactElement => {

    return <Spinner color={color} size={size}><i/></Spinner>
};

export const Spinner = styled.div<MiniLoaderProps>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  display: block;
  i {
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    position: relative;
    display: block;
  }

  i::after {
    position: absolute;
    left: 0;

    clip: rect(0, ${props => props.size}px, ${props => props.size}px, ${props => +props.size/2}px);
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    content: '';
    animation: spinner-circle 0.8s ease-in-out infinite;
    border-radius: 50%;
    box-shadow: inset 0 0 0 ${props => +props.size/13}px ${props => props.color};
  }

  @keyframes spinner-circle {
    0% {
      transform: rotate(-180deg);
    }
    100% {
      transform: rotate(180deg);
    }
  }
`

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`